import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import {
  SubBar,
  MainView,
  SidebarView,
  CustomersList,
  Button,
  PaginationNavigation,
  Message,
} from "lib/components/index";
import { open as openEditCustomerModal } from "modules/customers/EditCustomerModal";
import {
  stateSelector,
  initializeView,
  destroyView,
  setParamsWithLocationQuery,
  setFilters,
  changePagination,
  fetchRecords,
} from "./index";
import CustomersListFilters from "./CustomersListFilters";

@connect(
  (state) => ({
    sidebarVisible: state.app.sidebarVisible,
    allRecords:
      stateSelector(state).allRecords &&
      stateSelector(state).allRecords.model &&
      stateSelector(state).allRecords.model.records,
    filteredRecords: stateSelector(state).filteredRecords,
    fetchDone: stateSelector(state).allRecords.fetchDone,
    fetchLoading: stateSelector(state).allRecords.fetchLoading,
    fetchFailed: stateSelector(state).allRecords.fetchFailed,
    filters: stateSelector(state).filters,
    totalCount:
      stateSelector(state).allRecords &&
      stateSelector(state).allRecords.model &&
      stateSelector(state).allRecords.model.meta.total_count,
    aggregations: stateSelector(state).aggregations,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        setParamsWithLocationQuery,
        setFilters,
        changePagination,
        fetchRecords,
        openEditCustomerModal,
      },
      dispatch
    )
)
export default class CustomersListView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
    this.props.setParamsWithLocationQuery(this.props.location.query);
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  handleNewCustomerClick(event) {
    event.preventDefault();
    this.props.openEditCustomerModal();
  }

  render() {
    const {
      fetchRecords,
      fetchDone,
      fetchLoading,
      fetchFailed,
      allRecords,
      aggregations,
      filters,
      totalCount,
      offset,
      limit,
      setFilters,
      changePagination,
      filteredRecords,
      sidebarVisible,
    } = this.props;

    return (
      <SidebarView.Container>
        <SidebarView.Sidebar label={I18n.t("papp.common.filters_title")} extended={sidebarVisible}>
          <CustomersListFilters aggregations={aggregations} filters={filters} onFiltersChange={setFilters} />
        </SidebarView.Sidebar>

        <SidebarView.Content hasSidebar={sidebarVisible}>
          <MainView.Container>
            <SubBar hasSidebar={sidebarVisible}>
              <div className="pull-left u-inlineFlexRow">
                <h1>{I18n.t("papp.customers.CustomersListView.title")}</h1>
              </div>

              <div className="pull-right">
                {fetchDone && filteredRecords.length > 0 && (
                  <PaginationNavigation
                    offset={offset}
                    limit={limit}
                    totalCount={totalCount}
                    onChange={changePagination}
                    name="clientsLimit"
                  />
                )}

                <Button primary as="a" className="u-marginLeft" onClick={bind(this.handleNewCustomerClick, this)}>
                  {I18n.t("papp.customers.CustomersListView.add_new_customer")}
                </Button>
              </div>
            </SubBar>

            <MainView.Content grayBackground hasSubBar>
              <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchRecords} />
              {fetchDone && allRecords.length === 0 && (
                <MainView.DimmerContent
                  icon="sentiment_neutral"
                  title={I18n.t("papp.customers.CustomersListView.no_records_title")}
                >
                  <p>
                    {I18n.t("papp.customers.CustomersListView.no_records_message")}{" "}
                    <a className="u-cursorPointer" onClick={bind(this.handleNewCustomerClick, this)}>
                      {I18n.t("papp.customers.CustomersListView.no_records_add_new_link")}
                    </a>
                  </p>
                </MainView.DimmerContent>
              )}
              {fetchDone && allRecords.length > 0 && filteredRecords.length === 0 && (
                <Message>{I18n.t("papp.common.no_results_message")}</Message>
              )}
              {fetchDone && allRecords.length > 0 && filteredRecords.length > 0 && (
                <CustomersList customers={filteredRecords} />
              )}
            </MainView.Content>
          </MainView.Container>
        </SidebarView.Content>
      </SidebarView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/customers/CustomersListView/CustomersListView.jsx